import React, { useEffect, useState } from "react";
import { Row, Col, Card, CardBody, CardTitle } from "reactstrap";
import { useNavigate } from "react-router-dom";
import { getDealLogs } from "http/fundLync/deal.helper";

const statusMapping = {
  1: { title: 'E-Signed', icon: 'bx bx-pen' },
  2: { title: 'Submitted By Partner', icon: 'bx bx-partner' },
  3: { title: 'Draft', icon: 'bx bx-edit' },
  4: { title: 'Submitted', icon: 'bx bx-send' },
  5: { title: 'Sent For E-Signing', icon: 'bx bx-envelope' },
  6: { title: 'Prospect', icon: 'bx bx-user' },
  7: { title: 'Meeting Done', icon: 'bx bx-video' },
  8: { title: 'WIP', icon: 'bx bx-wrench' },
  9: { title: 'Referred', icon: 'bx bx-share' },
  10: { title: 'Queried', icon: 'bx bx-question-mark' },
  11: { title: 'Approved', icon: 'bx bx-check' },
  12: { title: 'Rejected', icon: 'bx bx-x' },
  13: { title: 'On Hold', icon: 'bx bx-pause' },
  14: { title: 'Pre Sanction Documents', icon: 'bx bx-file' },
  15: { title: 'Live', icon: 'bx bx-live' },
  16: { title: 'Customer backed out', icon: 'bx bx-exit' },
  17: { title: 'Terms conditions not accepted', icon: 'bx bx-error' },
  18: { title: 'Deal lost', icon: 'bx bx-error' },
  19: { title: 'Sanctioned', icon: 'bx bx-check' },
  20: { title: 'Credit Appraisal', icon: 'bx bx-check' }
};

const DealsTimeline = () => {
  const [dealLogs, setDealLogs] = useState([]);
  const navigate = useNavigate();

  const urlParams = new URLSearchParams(window.location.search);
  const encodedId = urlParams.get("id");
  const decodedId = atob(encodedId);

  useEffect(() => {
    getDealLogs({ tableName: "deals", refId: decodedId })
      .then((response) => {
        if (response.code === 200 || response.status) {
          setDealLogs(response.data?.rows || []);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }, [decodedId]);

  document.title = "Deal Timeline | FundLync";

  const renderStatus = () => {
    const statusData = dealLogs.filter((deal) => deal.after.dealStatus);

    if (statusData.length === 0) return null;
    return (
      <React.Fragment>
        {statusData.map((deal, index) => (
          <li className="event-list" key={`${deal.id}-${index}`}>
            <div className="event-timeline-dot">
              <i className={`bx bx-right-arrow-circle`} />
            </div>
            <div className="d-flex">
              <div className="me-3">
                <i className={`bx ${statusMapping[deal?.after?.dealStatus]?.icon} h2 text-primary`} />
              </div>
              <div className="flex-grow-1">
                <div>
                  <h5>{statusMapping[deal?.after?.dealStatus]?.title}</h5>
                  <p className="text-muted">
                    {statusMapping[deal?.after?.dealStatus]?.title} By:-{" "}
                    {deal.createdByUser?.firstName + ' ' + (deal.createdByUser?.lastName || '')}
                  </p>
                  <p className="text-muted">
                    {statusMapping[deal?.after?.dealStatus]?.title} On:-{" "}
                    {formatDate(deal.createdAt)}
                  </p>
                </div>
              </div>
            </div>
          </li>
        ))}
      </React.Fragment>
    );
  };


  return (
    <div>
      <div className="page-content">
        <div className="container-fluid">
          <Row className="vertical-scroll">
            <Col lg="12">
              <Card>
                <CardBody>
                  <CardTitle className="mb-5">Deal Timeline</CardTitle>
                  <div>
                    <ul className="verti-timeline list-unstyled">
                      {renderStatus()}
                    </ul>
                  </div>
                  <div className="d-flex gap-3 justify-content-end">
                    <button
                      className="btn btn-outline-secondary"
                      type="button"
                      onClick={() => navigate(-1)}
                    >
                      Back
                    </button>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
    </div>
  );
};

export default DealsTimeline;

const formatDate = (oldDate) => {
  const isoDateString = oldDate;
  const date = new Date(isoDateString);
  const options = {
    year: "numeric",
    month: "long",
    day: "numeric",
    hour: "numeric",
    minute: "numeric",
    second: "numeric",
  };
  const formattedDate = date.toLocaleDateString(undefined, options);

  return formattedDate;
};
